export default __webpack_public_path__ + "static/media/gallery14.07e1cd59.webp";